// removed by extract-text-webpack-plugin
module.exports = {"Title":"_34M7skpRcj7OSy9CBdnmtZ","Body":"_261-KayiHkiZCSp0QdvNE0","NotificationContainer":"_1kOULGGOB87xmsZelICFod","NotificationListItem":"_3k0M6ShbSlvEn5ZJ51ADG4","HeaderText":"_1b4FWl8OgKb_TyG8ttENkB","NotificationWrapper":"_3_henJzlkH-OfqikAtUSy4"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Header/NotificationDisplay/style.css
// module id = 1868
// module chunks = 0